module.exports = __webpack_public_path__ + "media/images/services/thumbnail/img_online-2bb08fe5d258bd65eb917cc8440e0d47.jpg";